import { Link } from 'react-router-dom'
import authProvider from '../../../../core/AuthenticationProvider'
import { Icon } from '../../../common/html/icon'
import { Tooltip } from '../../../common/tooltip'
import { COMPONENTS } from '../../../routers/constants'
import { ID_REPORTS, NAME_REPORTS } from '../constant'

export const CustomTdActionDownloadedFiles = ({ val }) => {
  const { orderId, isExpired, id, fileCategoryId } = val

  const handleDownloadFile = () => {
    if (isExpired) return null

    authProvider.getUser().then((user) => {
      window.location.href = `${process.env.REACT_APP_SERVICE_ENDPOINT}/Library/DownloadFile?DownloadedFileId=${id}&access_token=${user.access_token}`
    })
  }

  const disableDetail = fileCategoryId === ID_REPORTS[NAME_REPORTS.DYNAMIC]

  return (
    <div className="dFlex gap1">
      <div
        style={{
          pointerEvents: disableDetail ? 'none' : '',
        }}
      >
        <Tooltip tooltipContent="library.main.NOTI_DEAILS" isI18n>
          <Link
            to={`${COMPONENTS.userManagement.components.subscriptionPayment.components.orderDetail.route}?orderId=${orderId}`}
            target="_blank"
          >
            <Icon
              className="icon-open-new"
              style={{
                fontSize: 14,
                color: disableDetail ? '#9C9C9C' : '#8EA492',
              }}
            />
          </Link>
        </Tooltip>
      </div>

      <Tooltip tooltipContent="library.main.DOWNLOAD" isI18n>
        <Icon
          className="icon-download"
          style={{
            fontSize: 14,
            color: isExpired ? '#9C9C9C' : '#0553A5',
            cursor: !isExpired ? 'pointer' : 'not-allowed',
          }}
          onClick={handleDownloadFile}
        />
      </Tooltip>
    </div>
  )
}
